;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('zlTags', TagsDirective)

  TagsDirective.$inject = []

  function TagsDirective () {
    return {
      restrict: 'E',
      bindToController: true,
      controller: ['ColorService', function (ColorService) {
        var self = this
        self.$onInit = () => {
          _.extend(this, {
            getLuminance: ColorService.getLuminance
          })
        }
      }],
      templateUrl: '/app/common/directives/tags/tags.html',
      controllerAs: 'TagsCtrl',
      scope: {
        'tags': '=',
        'editable': '=',
        ngClick: '&'
      }
    }
  }
})(window.angular, window._)
